module.exports = __webpack_public_path__ + "img/layla.1dd44759.jpg";